//      
export default (a, b) => a === b;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/is-strict-equal.js